// extracted by mini-css-extract-plugin
export default {"wrapper":"Homepage_wrapper__uejHP","body":"Homepage_body__lfo9P","heading":"Homepage_heading__O-4vf"};